// @ts-nocheck
import DeclineModalController from './shared/decline_modal_controller';

export default class extends DeclineModalController {}
